<template>
  <svg class="svg-icon" aria-hidden="true">
    <use :xlink:href="iconID" />
  </svg>
</template>


<script>
export default {
  name: 'SvgIcon',
  props: {
    iconName: {
      type: String,
      required: true
    },
  },
  computed: {
    iconID() {
      return `#icon-${this.iconName}`
    },
  }
}
</script>


<style>
.svg-icon {
  margin: 0 5px 0 0;
  width: 1.1em;
  height: 1.1em;
  vertical-align: -0.2em;
  fill: currentColor;
  overflow: hidden;
}
</style>
